const React = require('react');
const { createElement: h } = React;
const NodeIcon = require('./NodeIcon');
const { getTileTheme } = require('../lib/tileTheme');

// Compact square tile that matches the reference design:
//   [ pastel rounded square ]
//   [        ICON          ]
//   [        Title         ]
//   [   subtitle (muted)   ]
// All three lines live INSIDE the tinted square. Title wraps to 2 lines max,
// subtitle to 1 line, so the tile keeps a fixed compact width regardless of text length.
function NodeTile(props) {
  var icon = props.icon;
  var logoUrl = props.logoUrl;
  var title = props.title;
  var subtitle = props.subtitle;
  var isDragging = props.isDragging;
  var nodeStatus = props.nodeStatus;
  var isWorkflowRunning = props.isWorkflowRunning;
  var eyeLookDir = props.eyeLookDir;
  var titleSlot = props.titleSlot; // optional pre-rendered title (for inline editing)
  var compact = !!props.compact;   // smaller variant for utility steps (set-variable)
  var glyphOverlay = props.glyphOverlay; // optional badge anchored to glyph corner
  var onLogoEdit = props.onLogoEdit; // optional: show pencil-on-hover to change tile logo
  var colorFamilyOverride = props.colorFamily; // optional: force a color family (e.g. tool nodes)
  // Agent nodes normally always show the robot glyph, but TOOL nodes (which
  // are agent nodes too) may carry a user-picked logo — this opts them in.
  var allowAgentLogo = !!props.allowAgentLogo;

  var theme = getTileTheme(icon);
  var colorFamily = colorFamilyOverride || theme.family;
  var glyphStyle = theme.iconBg
    ? { background: theme.iconBg, color: theme.iconColor }
    : null;
  var showLogo = logoUrl && (icon !== 'agent' || allowAgentLogo);

  return h('div', {
    className: 'wf-node-tile wf-node-tile-color-' + colorFamily
      + (compact ? ' wf-node-tile-compact' : '')
  },
    h('div', { className: 'wf-node-tile-glyph-wrap' },
      h('div', { className: 'wf-node-tile-glyph' + (showLogo ? ' wf-node-tile-glyph-logo' : ''), style: glyphStyle },
        showLogo
          ? h('img', {
              src: logoUrl,
              alt: title || '',
              className: 'wf-node-tile-logo',
              onError: function(e) { e.target.style.display = 'none'; }
            })
          : h(NodeIcon, {
              type: icon,
              size: compact ? 22 : 32,
              isDragging: isDragging,
              nodeStatus: nodeStatus,
              isWorkflowRunning: isWorkflowRunning,
              eyeLookDir: eyeLookDir
            })
      ),
      glyphOverlay,
      onLogoEdit
        ? h('button', {
            type: 'button',
            className: 'wf-node-icon-edit-btn',
            title: 'Change image',
            'aria-label': 'Change image',
            onMouseDown: function(e) { e.stopPropagation(); },
            onClick: function(e) { e.stopPropagation(); onLogoEdit(); }
          },
            h('svg', { width: 11, height: 11, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2.2, strokeLinecap: 'round', strokeLinejoin: 'round' },
              h('path', { d: 'M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z' }),
              h('circle', { cx: 12, cy: 13, r: 4 })
            )
          )
        : null
    ),
    titleSlot
      ? h('div', { className: 'wf-node-tile-title' }, titleSlot)
      : h('div', { className: 'wf-node-tile-title', title: title }, title || ''),
    subtitle
      ? h('div', { className: 'wf-node-tile-subtitle', title: subtitle }, subtitle)
      : null
  );
}

module.exports = NodeTile;
